import React from "react";

const MoneyIcon = () => {
	return (
		<>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="30"
				height="29"
				viewBox="0 0 30 29"
				fill="none"
			>
				<path
					d="M26.6719 7.25H3.10938C2.60887 7.25 2.20312 7.65574 2.20312 8.15625V20.8438C2.20312 21.3443 2.60887 21.75 3.10938 21.75H26.6719C27.1724 21.75 27.5781 21.3443 27.5781 20.8438V8.15625C27.5781 7.65574 27.1724 7.25 26.6719 7.25Z"
					stroke="currentColor"
					strokeWidth="1.8"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M14.8906 18.125C16.8927 18.125 18.5156 16.502 18.5156 14.5C18.5156 12.498 16.8927 10.875 14.8906 10.875C12.8886 10.875 11.2656 12.498 11.2656 14.5C11.2656 16.502 12.8886 18.125 14.8906 18.125Z"
					stroke="currentColor"
					strokeWidth="1.8"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M20.3281 7.25L27.5781 13.5938"
					stroke="currentColor"
					strokeWidth="1.8"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M20.3281 21.75L27.5781 15.4062"
					stroke="currentColor"
					strokeWidth="1.8"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M9.45312 7.25L2.20312 13.5938"
					stroke="currentColor"
					strokeWidth="1.8"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M9.45312 21.75L2.20312 15.4062"
					stroke="currentColor"
					strokeWidth="1.8"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</>
	);
};
export default MoneyIcon;
